import api from '../../api/axios';

export const createAdvanceSalary = ({ employeeId, amount, months }) => {
  return api.post('/advance-salary/create', {
    employeeId,
    amount,
    months
  });
};
